import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React from 'react';

interface AbbreviationDialogProps {
    open: boolean;
    onClose: () => void;
    onAddAbbreviation: (abbr: { abbreviation: string; sic: string; model: string }) => void;
}

export const AbbreviationDialog: React.FC<AbbreviationDialogProps> = ({ open, onClose, onAddAbbreviation }) => {
    const [form, setForm] = React.useState({ abbreviation: '', sic: '', model: '' });

    return (
        <Dialog open={open}>
            <DialogTitle>Add Abbreviation</DialogTitle>
            <DialogContent>
                <TextField
                    label='Abbreviation'
                    value={form.abbreviation}
                    onChange={(evt) => setForm({ ...form, abbreviation: evt.target.value })}
                    fullWidth
                    margin='dense'
                />
                <TextField
                    label='SIC'
                    value={form.sic}
                    onChange={(evt) => setForm({ ...form, sic: evt.target.value })}
                    fullWidth
                    margin='dense'
                />
                <TextField
                    label='Model'
                    value={form.model}
                    onChange={(evt) => setForm({ ...form, model: evt.target.value })}
                    fullWidth
                    margin='dense'
                />
            </DialogContent>
            <DialogActions>
                <Button color='secondary' onClick={onClose}>
                    Cancel
                </Button>
                <Button color='primary' onClick={() => onAddAbbreviation(form)}>
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
};
